import { observer } from 'mobx-react';
import * as React from 'react';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';
import { MessageBarButton } from 'office-ui-fabric-react/lib/Button';
import strings from 'owa-strings/owa-options-strings';
import store from '../store/store';
import { getPremiumUser } from '../actions/getPremiumUser';
import { fetchAndValidateDomain } from '../actions/fetchAndValidateDomain';
import { format } from 'owa-strings';
import { removeSecondaryUserEmail } from '../actions/removeSecondaryUserEmail';
import DomainEnrollOptionFull from './DomainEnrollOptionFull';

@observer
export default class DomainOptionFullForSecondaryUser extends React.Component<{}, {}> {
    componentDidMount() {
        getPremiumUser();
        fetchAndValidateDomain();
    }

    render() {
        if (store.userInfo.isProsumerConsumerMailbox) {
            var messageBarType: MessageBarType;
            var messageBarText;

            if (store.domainState.isDomainCreated && store.domainState.isValid) {
                messageBarType = MessageBarType.success;
                messageBarText = format(
                    strings.options_premium_PersonalizedEmailAddressText,
                    store.userInfo.prosumerEmailAddress
                );
            } else {
                messageBarType = MessageBarType.warning;
                messageBarText = format(
                    strings.options_premium_SecondaryUserErrorText,
                    store.userInfo.prosumerEmailAddress
                );
            }

            return (
                <div>
                    <MessageBar
                        messageBarType={messageBarType}
                        isMultiline={true}
                        actions={
                            <div>
                                <MessageBarButton
                                    onClick={this.deleteSecondaryUserEmail}
                                    disabled={store.userInfo.isRemovingEmailAddress}>
                                    {strings.options_premium_RemoveAddressText}
                                </MessageBarButton>
                            </div>
                        }>
                        {messageBarText}
                        <a href="https://go.microsoft.com/fwlink/?linkid=871933" target="_blank">
                            {strings.options_premium_AdvancedSecurityContent_LearnMore}
                        </a>
                    </MessageBar>
                </div>
            );
        } else {
            return <DomainEnrollOptionFull />;
        }
    }

    private deleteSecondaryUserEmail = () => {
        removeSecondaryUserEmail(store.userInfo.prosumerEmailAddress);
    };
}
